// extracted by mini-css-extract-plugin
export default {"button":"style_button__Xsp+6","icon":"style_icon__5B0Ni"};